import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "border border-gray-300 rounded-md p-4" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:flex-wrap gap-x-4" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex flex-row items-end pb-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-xs text-gray-500 pr-5",
  style: {"width":"280px"}
}
const _hoisted_7 = { class: "text-lg font-bold text-sm" }
const _hoisted_8 = { class: "flex flex-wrap gap-4" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanySelector = _resolveComponent("CompanySelector")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_SiteSelector = _resolveComponent("SiteSelector")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_OperatorStatus = _resolveComponent("OperatorStatus")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, {
    style: {"height":"calc(100vh - 80px)"},
    class: "bg-white"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { style: {"padding":"0px","height":"auto"} }, {
        default: _withCtx(() => [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "h-12 p-4 shadow-md" }, "ダッシュボード", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_form, {
                model: _ctx.searchForm,
                "label-width": "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form_item, {
                      label: "契約会社",
                      class: "md:w-80"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CompanySelector, {
                          modelValue: _ctx.searchForm.company_code,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.company_code) = $event)),
                          isSearch: true,
                          disabled: _ctx.loginUserRole !== _ctx.ROLES.SYSTEM
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "現場",
                      class: "md:w-80"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SiteSelector, {
                          company_code: _ctx.searchForm.company_code,
                          isSearch: true,
                          modelValue: _ctx.searchForm.site_code,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.site_code) = $event))
                        }, null, 8, ["company_code", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "作業状態",
                      class: "md:w-80"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.isWorkStatus,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isWorkStatus) = $event)),
                          placeholder: "作業状態を選択してください",
                          onChange: _ctx.handleWorkStatusChange
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: _ctx.ALL,
                              label: "すべて"
                            }, null, 8, ["value"]),
                            _createVNode(_component_el_option, {
                              value: true,
                              label: "作業中"
                            }),
                            _createVNode(_component_el_option, {
                              value: false,
                              label: "作業完了"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "休憩状態",
                      class: "md:w-80"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.isBreakStatus,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isBreakStatus) = $event)),
                          placeholder: "休憩状態を選択してください",
                          disabled: !_ctx.isWorkStatus
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: _ctx.ALL,
                              label: "すべて"
                            }, null, 8, ["value"]),
                            _createVNode(_component_el_option, {
                              value: true,
                              label: "休憩中"
                            }),
                            _createVNode(_component_el_option, {
                              value: false,
                              label: "休憩状態にはありません"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "デバイス状態",
                      class: "md:w-80"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.appStatus,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.appStatus) = $event)),
                          placeholder: "デバイス状態を選択してください",
                          disabled: !_ctx.isWorkStatus,
                          onChange: _ctx.handleAppStatusChange
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: _ctx.ALL,
                              label: "すべて"
                            }, null, 8, ["value"]),
                            _createVNode(_component_el_option, {
                              value: "normal",
                              label: "正常"
                            }),
                            _createVNode(_component_el_option, {
                              value: "not_comm",
                              label: "通信不能"
                            }),
                            _createVNode(_component_el_option, {
                              value: "not_normal",
                              label: "計測不能"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "HSI",
                      class: "md:w-80"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.zoneStatus,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.zoneStatus) = $event)),
                          multiple: "",
                          placeholder: "HSIを選択してください",
                          disabled: !_ctx.isWorkStatus || _ctx.appStatus === 'not_comm' || _ctx.appStatus === 'not_normal'
                        }, {
                          tag: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zoneStatus, (value) => {
                              return (_openBlock(), _createBlock(_component_el_tag, {
                                key: value,
                                color: _ctx.zones.find(zone => zone.value === value)?.color
                              }, null, 8, ["color"]))
                            }), 128))
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zones, (item) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (_ctx.appStatus !== 'normal' || item.value !== 0)
                                  ? (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value,
                                      disabled: _ctx.zoneStatus.length === 1 && _ctx.zoneStatus.includes(item.value)
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_4, [
                                          _createVNode(_component_el_tag, {
                                            color: item.color,
                                            style: {"margin-right":"8px"},
                                            size: "small"
                                          }, null, 8, ["color"]),
                                          _createElementVNode("span", {
                                            style: _normalizeStyle({ color: item.color })
                                          }, _toDisplayString(item.label), 5)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value", "disabled"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      class: "w-24",
                      type: "primary",
                      onClick: _ctx.handleSearchButton
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("検索")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["text-xs text-gray-500 flex-grow", {
                    'pl-5': _ctx.alarmMessage.length > 0,
                    'px-5': _ctx.alarmMessage.length === 0
                }])
            }, " 最大100現場表示します ", 2),
            (_ctx.alarmMessage.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "最大50件表示します"))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_container, { style: {"height":"0px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, { style: {"padding-block":"0px"} }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mTableData, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.site.site_code,
                  class: "mb-8"
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.site.site_name), 1),
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.operators, (operator) => {
                      return (_openBlock(), _createBlock(_component_OperatorStatus, {
                        key: item.site.site_code + '_' + operator.operator.operator_code,
                        data: operator,
                        onRefreshOperatorStatus: _ctx.handleRefreshOperatorStatus
                      }, null, 8, ["data", "onRefreshOperatorStatus"]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }),
          (_ctx.alarmMessage.length > 0)
            ? (_openBlock(), _createBlock(_component_el_aside, {
                key: 0,
                width: "280px",
                class: "pr-5"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alarmMessage, (alarm, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["mb-4", _ctx.getHSIBackgroundColor(alarm.heat_strain_index)])
                    }, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formattedDate(alarm.check_timestamp)), 1),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(alarm.site_name), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("a", {
                          href: '#' + alarm.site_code + '_' + alarm.operator_code,
                          class: "underline text-blue-500"
                        }, _toDisplayString(alarm.operator_name), 9, _hoisted_12),
                        _createTextVNode("さんが" + _toDisplayString(_ctx.getHSIStatus(alarm.heat_strain_index)) + "体温に達しました。 ", 1)
                      ])
                    ], 2))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode(_component_el_footer, { style: {"height":"20px"} })
    ]),
    _: 1
  }))
}